<template>
    <div class="body_main">
        <div class="body_bd">
            <!-- 今日日期标题 -->
            <div class="today_header">
                <div class="today_badge">
                    <el-icon style="margin-right: 6px;"><Calendar /></el-icon>
                    <span class="today_label">今日预约</span>
                    <el-tag type="success" effect="dark" class="today_date_tag">{{ todayLabel }}</el-tag>
                </div>
                <div class="today_count">
                    共 <span class="count_num">{{ totalCount }}</span> 条预约
                </div>
            </div>

            <!-- 搜索 -->
            <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
                <el-form-item label="预约人">
                    <el-input
                        v-model="queryParams.cardPatientName"
                        placeholder="预约人（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input
                        v-model="queryParams.cardPatientPhone"
                        placeholder="手机号（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="预约单号">
                    <el-input
                        v-model="queryParams.reSerialNo"
                        placeholder="预约单号（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" @click="getTodayReservationListInfo">搜索</el-button>
                    <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格 -->
            <div class="table_bd">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :max-height="tableHeight"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column type="index" label="序号" width="50"> </el-table-column>
                    <el-table-column
                        prop="reSerialNo"
                        label="预约单号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        label="预约人"
                        width="180">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image class="elImage" :src="scope.row.avatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 16px; font-weight: 600; line-height: 24px">{{ scope.row.cardPatientName }}</span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{ scope.row.sexText }}  {{ scope.row.age }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人手机号"
                        width="140">
                        <template #default="scope">
                            <span>{{ scope.row.cardPatientPhone === null ? '---' : scope.row.cardPatientPhone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约时间"
                        width="200">
                        <template #default="scope">
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.reTime === null ? '---' : scope.row.reTime }} {{scope.row.reTimeTypeText}}{{scope.row.reNo}}号</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单状态"
                        width="100">
                        <template #default="scope">
                            <el-tag
                                :type="scope.row.reStatus === '5' ? 'success' : scope.row.reStatus === '6' ? '' :
                                scope.row.reStatus === '7' ? 'danger' : scope.row.reStatus === '8' ? 'warning' :
                                scope.row.reStatus === '4' ? 'info' : scope.row.reStatus === '3' ? 'danger' :
                                scope.row.reStatus === '1' ? 'danger' : ''"
                                disable-transitions>{{ scope.row.reStatusText }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约医生"
                        width="120">
                        <template #default="scope">
                            <span>{{ scope.row.doctorName === null ? '---' : scope.row.doctorName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="门诊科室"
                        width="120">
                        <template #default="scope">
                            <span>{{ scope.row.odName === null ? '---' : scope.row.odName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单类型"
                        width="90">
                        <template #default="scope">
                            <el-tag :type="scope.row.visitType === null || scope.row.visitType === '初诊'?'success':'warning'" disable-transitions>
                                {{ scope.row.visitType === null ? '初诊' : scope.row.visitType }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间"
                        width="170">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="180">
                        <template #default="scope">
                            <el-button type="warning" size="small" @click="handleSign(scope.row)" v-if="scope.row.reStatus === '8'">签到</el-button>
                            <el-button type="success" size="small" @click="openMedical(scope.row)" v-if="scope.row.reStatus === '5'">接诊</el-button>
                            <el-button type="info" size="small" disabled v-if="scope.row.reStatus !== '5' && scope.row.reStatus !== '8'">接诊</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import todayreservation from "@/assets/scripts/todayreservation/index";

export default todayreservation;
</script>

<style scoped>
.today_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
    margin-bottom: 16px;
}
.today_badge {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
}
.today_label {
    margin-right: 12px;
}
.today_date_tag {
    font-size: 14px;
}
.today_count {
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
}
.count_num {
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    margin: 0 4px;
}
</style>